import { Navigate } from "react-router-dom";
import { Alert, Box, Button, Container, Stack } from "@mui/material";
import CreateDataset from "datasets/components/CreateDataset";
import useDatasets from "datasets/hooks/useDatasets";
import yn from "yn";
import { PlusIcon } from "~/assets/icons";
import DatasetList from "~/components/DatasetList";
import PageHeader from "~/components/PageHeader";
import ScrollableTabContent from "~/components/ScrollableTabContent";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import useUserPermission from "~/hooks/useUserPermission";
import { ROUTE_404 } from "~/router/constants";

const { VITE_DATASETS_ENABLED } = import.meta.env;

const title = "Datasets";

const Datasets = () => {
  useDocumentTitle(title);
  // Note: App header is managed by DataBrowser parent component
  const hasCreatePermission = useUserPermission("create:catalog-dataset");
  const { data: datasets, isLoading, error } = useDatasets();
  const showEmpty = !isLoading && !error && datasets?.length === 0;

  if (!yn(VITE_DATASETS_ENABLED)) {
    return <Navigate to={ROUTE_404} replace />;
  }

  return (
    <ScrollableTabContent bgcolor="common.dimmedPageBackground">
      <Container maxWidth="lg" sx={{ pt: 2, pb: 3 }}>
        <Stack gap={2}>
          <Box display="flex" alignItems="center" justifyContent="space-between" minHeight={40}>
            <PageHeader lineHeight={1.8}>All Datasets</PageHeader>
            {hasCreatePermission && !error && !showEmpty && (
              <CreateDataset
                callToAction={
                  <Button aria-label="Create dataset" variant="contained" startIcon={<PlusIcon />}>
                    New Dataset
                  </Button>
                }
              />
            )}
          </Box>
          {error && (
            <Alert severity="error" variant="outlined" data-testid="dataset-list-error">
              Unable to load datasets
            </Alert>
          )}
          <DatasetList showEmpty={showEmpty} />
        </Stack>
      </Container>
    </ScrollableTabContent>
  );
};

export default Datasets;
